angular
  .module("erp.other.clickShopOpening", ["ui.router", "clickShopOpening.service", "mg.widget.select3"])
  .config([
    "$stateProvider",
    "$httpProvider",
    function($stateProvider, $httpProvider) {
      $httpProvider.defaults.headers.put["Content-Type"] = "application/json;charset=utf-8";
      $stateProvider.state("clickShopOpening", {
        url: "/erp/other/clickShopOpening",
        templateUrl: "tpl/outbox.htm",
        controllerAs: "vm",
        controller: "baseCtrl",
        resolve: {},
      });
    },
  ])

  .controller("baseCtrl", [
    "$scope",
    "$http",
    "$sce",
    "$q",
    "kit",
    "$timeout",
    function($scope, $http, $sce, $q, kit, $timeout) {
      var vm = this;
      // var params = kit.getParams();
      vm.tpl = "tpl/outbox.htm";
      vm.Banner = {
        topBanner: [
          {
            image: "//img2.mangoerp.com/userbucket/adminadmin/2025-12-10/1765335508051-3kk4c934k.png",
            title: "tiktok",
            url: "//www.mangoerp.com/erp/other/clickShopOpeningDetail/23",
          },
          {
            image: "//img2.mangoerp.com/userbucket/adminadmin/2026-03-26/1774502014588-qubuv0zs6.png",
            title: "shoppe",
            url: "https://shopee.cn/m/registration/collect?form_token=UVh5VjNxem9Wdmx0QmtZREg%2FhMkdwiQsj%2FRWMTrt0KE%3D&source_token=Nkl4Q1NwYjYxQW1oNmUwUOl6Wcq0gMT9vPFZ2fcwjgA%3D",
          }
        ],
      };

      if (vm.Banner.topBanner && vm.Banner.topBanner.length > 1) {
        $timeout(function() {
          // https://www.swiper.com.cn/api/effects/193.html 文档地址
          var swiper = new Swiper(".swiper-container-topBanner", {
            spaceBetween: 30,
            loop: false,
            loopFillGroupWithBlank: true,
            autoplay: {
              delay: 2000, //3秒切换一次
              disableOnInteraction: false,
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
        }, 100);
      }

      // 获取国家
      vm.getCountry = function() {
        vm.countryList = [];
        $http.get("/erp/site/manage/getLabel").then(function(response) {
          var res = response.data;
          if (res.success) {
            vm.countryList = res.data.list;
          }
          vm.countryList = vm.countryList.filter(function(item) {
            return item.labelList && item.labelList.length;
          });
        });
      };
      vm.getCountry();

      // 获取所有
      vm.getSiteManage = function() {
        var labelIdList = [];
        vm.countryList.forEach(function(item) {
          if (item.selectedIds) {
            item.selectedIds.forEach(function(id) {
              labelIdList.push(id);
            });
          }
        });
        var newlabelIdList = labelIdList.join(',');
        $http.get("/erp/site/manage/getSiteManage?labelIdList=" + newlabelIdList +  "&siteManage=" + (vm.siteManage || '')).then(function(response) {
          var res = response.data;
          if (res.success) {
            vm.listdate = [];
            vm.listdate = res.data.list;
            // 示例：在 vm.listdate 数据处理时转换
            vm.listdate.forEach(function(item) {
              item.logo = item.logo ? item.logo.replace(/^https?:/, '') : '';
            });
          }
        });
      };
      vm.getSiteManage();

      // 入驻
      vm.OpenRegistration = function(item) {
        window.open(item.channel);
      };

      // 了解更多
      vm.learnMore = function(item) {
        window.location.href = "/erp/other/clickShopOpeningDetail/" + item.id;
      };

      vm.onChange = function(v) {
        v.selectedIds = [];
        $timeout(function () {
          _.each(v.labelList, function (item) {
            if (item._selected) {
              v.selectedIds.push(item.labelId);
            }
          });
          vm.getSiteManage();
        }, 100);
      };

      // 重置
      vm.rotate = function() {
        vm.countryList.forEach(function(item) {
          item.selectedIds = [];
          item.selectedIdlist = '';
        });
        vm.selectedCategories = [];
        vm.siteManage = '';
        vm.getSiteManage();
      };

    },
  ]);
